
import Index from '~/pages/_landing/index'
export default Index
